<script>
import Config from '@/config';
import {mapGetters} from 'vuex';
import Main from '@/mixins/main';
import Size from '@/mixins/size';
import {List, PullRefresh} from 'vant';
import {getBalanceRecords} from '@/api';
import {pageIsFinish} from '@/libs/util';

export default {
  mixins: [
    Main,
    Size
  ],
  components: {
    [List.name]: List,
    [PullRefresh.name]: PullRefresh
  },
  data() {
    return {
      page: 1,
      balances: [],

      loading: false,
      finished: false,
      refreshing: false
    };
  },
  computed: {
    ...mapGetters([
      'user'
    ]),
    amount() {
      return this.user ? this.user.amount.toFixed(2) : '--.--';
    }
  },
  mounted() {
    window.document.title = '速电通-余额明细';

    this.refreshMyInfo();
  },
  methods: {
    refresh() {
      this.page = 1;
      this.finished = false;
      this.loadData();

      this.refreshMyInfo();
    },
    loadData() {
      if (this.refreshing) {
        this.balances = [];
        this.refreshing = false;
      }

      this.loading = true;
      getBalanceRecords(this.page, Config.pageSize).then(response => {
        if (response.data.code === Config.successCode) {
          response.data.body.data = response.data.body.data.map(value => {
            value.change = value.change.toFixed(2);
            return value;
          });

          this.balances = this.page === 1 ? response.data.body.data : this.balances.concat(response.data.body.data);
          this.finished = pageIsFinish(response.data.body);
          this.page = response.data.body.page + 1;
        }
      }).finally(() => this.loading = false).catch(() => this.finished = true);
    },
    toRecharge() {
      this.$router.push({name: 'recharge'});
    }
  }
}
</script>

<template>
  <van-pull-refresh v-model="refreshing" @refresh="refresh" id="balance">
    <div class="info">
      <div class="label">账户余额</div>
      <div class="amount-button">
        <div class="amount">￥{{ amount }}</div>
        <div class="button" @click="toRecharge">立即充值</div>
      </div>
    </div>
    <div class="amount-history">
      <div class="title">余额明细</div>
      <van-list v-model="loading" :finished="finished" :finished-text="balances.length === 0 ? '' : '没有更多了'" @load="loadData">
        <div v-for="(item, index) in balances" :key="index" class="item">
          <div class="left">
            <div class="label">{{ item.description }}</div>
            <div class="datetime">{{ item.successAtShow }}</div>
          </div>
          <div class="change-value" :class="item.type === 1 ? 'add' : 'sub'">{{ item.type === 1 ? '+' : '-' }}{{ item.change }}</div>
        </div>
      </van-list>
    </div>
    <div v-if="balances.length === 0" :style="{height: (height - 186) + 'px'}" class="no-data">
      <div class="content">
        <img src="../assets/images/no-data.png"/>
      </div>
    </div>
  </van-pull-refresh>
</template>

<style scoped>
#balance .info {
  padding: 12px 24px 12px 12px;
  background-color: #009251;
}

#balance .info .label {
  color: white;
  font-size: 16px;
  font-weight: 500;
}

#balance .info .amount-button {
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-top: 24px;
}

#balance .info .amount-button .amount {
  color: white;
  font-size: 32px;
  font-weight: bold;
}

#balance .info .amount-button .button {
  display: flex;
  align-items: center;
  justify-content: center;

  color: #009251;
  font-size: 14px;
  font-weight: bold;
  padding: 6px 12px;
  border-radius: 14px;
  background-color: white;
}


#balance .amount-history {
  margin-top: 8px;
  background-color: white;
}

#balance .amount-history .title {
  color: #333333;
  font-size: 16px;
  font-weight: bold;
  padding: 24px 12px 12px 12px;
}

#balance .amount-history .item {
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin: 0 12px;
  padding: 12px 0;
  border-bottom: 1px solid #EEEEEE;
}

#balance .amount-history .item .left {
  display: flex;
  flex-direction: column;
}

#balance .amount-history .item .left .label {
  color: #333333;
  font-size: 14px;
  font-weight: 500;
}

#balance .amount-history .item .left .datetime {
  color: #9d9d9d;
  font-size: 12px;
  font-weight: 500;
  margin-top: 8px;
}

#balance .amount-history .item .change-value {
  font-size: 18px;
  font-weight: bold;
}

#balance .amount-history .item .change-value.add {
  color: #009251;
}

#balance .amount-history .item .change-value.sub {
  color: #FC2313;
}
</style>
